import classes from 'dom-helpers/class';
import create from 'dom-create-element';
import 'whatwg-fetch';
import framework from './framework';
import config from './config';
import cache from './cache';

const utils = {

    addRoutingEL(a) {
        a.forEach((el) => {
            el.onclick = utils.handleRoute;
        });
    },

    removeRoutingEL(a) {
        a.forEach((el) => {
            el.onclick = null;
        });
    },

    handleRoute(e) {
        const target = e.currentTarget;

        if (classes.hasClass(target, 'no-route') || (target.hasAttribute('target') && target.getAttribute('target') === '_blank')) {
            return;
        }

        e.preventDefault();
        framework.go(target.getAttribute('href'));
    },

    getSlug(req, options) {
        const params = Object.keys(req.params).length === 0 && JSON.stringify(req.params) === JSON.stringify({});
        let route = req.route === config.BASE ? '/home' : req.route;

        if (!params) {
            for (var key in req.params) {
                if (req.params.hasOwnProperty(key)) {
                    if (route.indexOf(key) > -1) {
                        route = route.replace(`:${key}`, options.sub ? '' : req.params[key]);
                    }
                }
            }
        }

        if (route.substring(route.length - 1) === '/') {
            route = route.slice(0, -1);
        }

        return route.substr(1);
    },

    loadPage(req, view, options, done) {

        const slug = utils.getSlug(req, options);
        const cn = slug.replace('/', '-');

        const page = create({
            selector: 'div',
            id: `page-${cn}`,
            styles: `page page-${cn}`,
        });

        view.appendChild(page);

        if (!cache[slug] || !options.cache) {

            fetch(`/sections/${slug}.html`).then(res => {
                return res.text();
            }).then(object => {
                const html = object;

                page.innerHTML = html;

                if (options.cache) {
                    cache[slug] = html
                }

                done();
            });

        } else {
            setTimeout(() => {
                page.innerHTML = cache[slug]
                done()
            }, 1);
        }

        return page
    }
}

export default utils



/** WEBPACK FOOTER **
 ** ./pjax/utils.js
 **/